import { forwardRef } from 'react';

import { ActionIcon, ActionIconProps, cx } from 'ui';
import { IconMore } from 'ui/Icons';

import classes from './ActionIconTarget.module.css';

const ActionIconTarget = forwardRef<HTMLButtonElement, { loading: boolean } & ActionIconProps>(
  ({ loading, className, ...rest }, ref) => {
    return (
      <ActionIcon
        variant="subtle"
        bg="white"
        radius="xl"
        color="cobalt"
        size="sm"
        {...rest}
        loading={loading}
        ref={ref}
        className={cx(classes.ActionIconTarget, className)}
      >
        <IconMore />
      </ActionIcon>
    );
  }
);
ActionIconTarget.displayName = 'ActionIconTarget';
export { ActionIconTarget };
